import { createContext } from 'react';

const contributionContext = createContext();

export default contributionContext;
